import React, { Fragment, useState, useEffect, Component, useContext } from 'react';
import TableBuilder, { ApiRequestBuilder, FormOptionsBuilder, ToastBuilder, RegisteredInputsBuilder } from '../../GlobalComponents/Builders';
import { buildOptionsFromArray } from '../../GlobalComponents/Helpers';
import { ModalButtonBuilder } from '../../GlobalComponents/Builders';
import { Container, Row, Card, CardBody, Form, NavItem, NavLink, Nav, TabContent, TabPane } from 'reactstrap'
import { ContentLoader } from '../../Layout/Loader';
import { AccountContext } from '../../GlobalComponents/Authentication/Accounts';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import moment from 'moment';

const ConnectionList = () => {

    const [connectionData, setConnectionData] = useState([]);
    const [serviceData, setServiceData] = useState([]);

    const [isProcessing, setIsProcessing] = useState(true);
    const form = useForm();
    const { portalEmulation, isAdmin } = useContext(AccountContext)

    const [BasicTab, setBasicTab] = useState('0');

    const tabList = [
        {
            title: 'API',
            filter: 'parameter'
        },
        {
            title: 'CSV',
            filter: 'csv'
        }
    ]

    const fetchServices = () => {
        ApiRequestBuilder('servicesGet')
            .then(function(results) {
                setServiceData(results.data && results.data.length > 0 ? results.data : [])
            }
        )
    }

    const handleConnectionCreate = (newConnectionData) => {

        ApiRequestBuilder('connectionsPost', null, newConnectionData).then(function(results){
            if (results.data.id){
                ToastBuilder('success', 'Connection Creation Successful')
                window.location.href = process.env.PUBLIC_URL + '/connections/' + String(results.data.id)
            } 
            else {
                ToastBuilder('error', 'Unable to Create Connection')
            }
        }).catch((err) => {
            console.log(err);
            ToastBuilder('error', 'Unable to Create Connection')
        })
    }

    useEffect(() => {
    
        document.title = 'View Connections'

        ApiRequestBuilder('connectionsGet', null, null, { setIsProcessing })
            .then(function(results) {
                setConnectionData(results.data && results.data.length > 0 ? results.data : [])
            }
        )

    }, []);

    return (
            <Fragment>
                <ContentLoader isLoading={isProcessing}/>
                <Row>
                    <Container>
                        <Card>
                            <CardBody>
                                <Nav tabs>
                                    { tabList.map((tab, i) => 
                                        <NavItem key={tab.title}>
                                            <NavLink href="#" className={BasicTab === String(i) ? 'active' : ''} onClick={() => setBasicTab(String(i))}>{tab.title}</NavLink>
                                        </NavItem>
                                    )}
                                </Nav>
                                <TabContent activeTab={BasicTab}>
                                    { tabList.map((tab, i) =>
                                        (
                                            <TabPane className="fade show" tabId={String(i)} key={tab.title + i}>
                                                <TableBuilder
                                                    sortField={4}
                                                    subHeader={true}
                                                    sortOrderAsc={false}
                                                    columnsToSearch={portalEmulation.partnerId > 0 ? ['name', 'service'] : ['name', 'partner_name', 'service']}
                                                    data={connectionData.filter(connection => connection.type === tab.filter && connection.is_active !== 0)}
                                                    processing={isProcessing}
                                                    actions={ portalEmulation.partnerId > 0 ? <ModalButtonBuilder title='Create Connection' className='btn-secondary'
                                                        onClick={() => { fetchServices() }}
                                                        body={
                                                            <Form id='create-connection-form' onSubmit={form.handleSubmit(handleConnectionCreate)}>
                                                                <RegisteredInputsBuilder
                                                                    form={form}
                                                                    inputs={[
                                                                        {
                                                                            label: 'Name',
                                                                            size: 11,
                                                                            required: false,
                                                                            name: 'connectionName'
                                                                        },
                                                                        {
                                                                            label: 'Description',
                                                                            size: 11,
                                                                            required: false,
                                                                            name: 'description'
                                                                        },
                                                                        {
                                                                            label: 'Service',
                                                                            type: 'reactselect',
                                                                            size: 11,
                                                                            required: true,
                                                                            options: buildOptionsFromArray(serviceData, {label : 'name', value: 'id'}),
                                                                            name: 'service'
                                                                        }
                                                                    ]}/>
                                                            </Form>
                                                        }
                                                    /> : null }
                                                    title = 'Connections'
                                                    columns = {[
                                                        {
                                                            name: 'Partner',
                                                            selector: (row) => row.partner_name,
                                                            omit: portalEmulation.portalEmulationActive,
                                                            sortable: true,
                                                            center: true,
                                                        },
                                                        {
                                                            name: 'Name',
                                                            selector: (row) => <span style={{fontWeight: 400}} title={isAdmin ? 'Connection ID: ' + row.id : null}>{row.name}</span>,
                                                            sortable: true,
                                                            center: true,
                                                        },
                                                        {
                                                            name: 'Service',
                                                            selector: (row) => row.service,
                                                            sortable: true,
                                                            center: true,
                                                        },
                                                        {
                                                            name: 'Created At',
                                                            selector: (row) => row.created_at ? moment.utc(row.created_at * 1000).format('l') : '-',
                                                            sortable: true,
                                                            center: true,
                                                            sortFunction: (a, b) => {
                                                                return a.created_at - b.created_at
                                                            }
                                                        },
                                                        {
                                                            name: 'Manage',
                                                            selector: (row) => <Link to={`${process.env.PUBLIC_URL}/connections/` + row.guid}>View / Edit</Link>,
                                                            sortable: true,
                                                            center: true,
                                                        },
                                                    ]}
                                                />
                                            </TabPane>
                                        )
                                    )}   
                                </TabContent>
                                
                            </CardBody>
                        </Card>
                    </Container>
                </Row>
            </Fragment>
    );
};

export default ConnectionList;